/* SPOOKY CART — variant selection, quick view */
(function () {
  'use strict';
  const S = window.Spooky || (window.Spooky = {});
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  /* ---------- upsell cards on a variant option --------------------------- */
  // Each card shows the real variant behind it. When another option changes —
  // a different style, say — the cards have to follow, because a different
  // variant now sits behind each value.
  function repriceVariantBundle(picker, variants, current) {
    const tiers = $$('[data-variant-bundle-tier]', picker);
    if (!tiers.length) return;

    tiers.forEach((tier) => {
      const input = $('input', tier);
      const idx = Number(input.getAttribute('data-option-index'));
      const value = tier.getAttribute('data-option-value');

      const v = variants.find((x) =>
        x.options.every((opt, i) => (i === idx ? opt === value : opt === current[i]))
      );
      if (!v) return;

      const price = Number(v.price) || 0;
      let compare = Number(v.compare_at_price) || 0;
      if (compare < price) compare = price;
      const save = compare - price;
      const qty = parseInt(value, 10) || 1;

      const set = (sel, text) => { const el = $(sel, tier); if (el) el.textContent = text; };
      set('[data-vb-total]', S.formatMoney(price));
      set('[data-vb-compare]', S.formatMoney(compare));
      set('[data-vb-save]', (S.strings.bundleSave || 'Save [amount]').replace('[amount]', S.formatMoney(save)));
      if (qty > 1) {
        set('[data-vb-each]', (S.strings.bundleEach || '[amount] each').replace('[amount]', S.formatMoney(Math.round(price / qty))));
      }
      const pct = $('[data-vb-pct]', tier);
      if (pct) pct.textContent = '-' + (compare > 0 ? Math.round((save / compare) * 100) : 0) + '%';

      const saveEl = $('[data-vb-save]', tier);
      if (saveEl) saveEl.hidden = save <= 0;

      // A style with no variant for this bundle size must not stay selectable
      tier.hidden = false;

      // Only the chosen pack posts its per-unit rows. Disabled fields are left
      // out of the form data, which is exactly what we want here.
      const chosen = input.checked;
      $$('[data-vb-item]', tier).forEach((sel) => { sel.disabled = !chosen; });
    });
  }

  // Unit #1 also drives the variant itself, so the order line reads as the same
  // style the shopper put first rather than whatever was left selected above.
  function bindBundleItemRows(picker) {
    if (picker.dataset.itemRowsBound) return;
    picker.dataset.itemRowsBound = '1';

    picker.addEventListener('change', (e) => {
      const sel = e.target;
      if (!sel.matches || !sel.matches('[data-vb-item="1"]')) return;
      const idx = Number(sel.getAttribute('data-item-option-index'));
      const match = $$('input[type="radio"][data-option-index="' + idx + '"]', picker)
        .find((r) => r.value === sel.value);
      if (match && !match.checked) {
        match.checked = true;
        picker.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  /* ---------- variant picker ------------------------------------------- */
  function initVariants(root) {
    $$('[data-variant-picker]', root || document).forEach((picker) => {
      if (picker.dataset.bound) return;
      picker.dataset.bound = '1';

      const sectionEl = picker.closest('[data-product-section]');
      const dataEl = $('[data-variant-json]', sectionEl || document);
      if (!dataEl) return;

      let variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      const form = $('[data-product-form]', sectionEl);
      const idInput = form ? $('input[name="id"]', form) : null;
      const addBtn = form ? $('[data-add-to-cart]', form) : null;
      const priceEl = $('[data-product-price]', sectionEl);
      const inventoryEl = $('[data-product-inventory]', sectionEl);
      const gallery = $('[data-gallery]', sectionEl);
      const updateUrl = picker.getAttribute('data-update-url') !== 'false';

      // Only the controls that stand for a product option. The per-unit rows
      // inside a bundle card are selects too, and letting them in here shifts
      // every option along and stops any variant from matching.
      const selected = () =>
        $$('input[type="radio"][data-option-index]:checked, select[data-option-index]', picker)
          .map((el) => el.value);

      function match(options) {
        return variants.find((v) => v.options.every((opt, i) => opt === options[i]));
      }

      // A value is unavailable when variants matching the earlier options
      // exist for it but none of them are in stock.
      function isUnavailable(idx, value, current) {
        const candidates = variants.filter((v) =>
          v.options.every((opt, i) => (i === idx ? opt === value : i > idx ? true : opt === current[i]))
        );
        return candidates.length > 0 && !candidates.some((v) => v.available);
      }

      function updateOptionAvailability(current) {
        $$('input[type="radio"]', picker).forEach((input) => {
          const idx = Number(input.getAttribute('data-option-index'));
          input.disabled = isUnavailable(idx, input.value, current);
        });

        // Long option lists render as a <select>; grey out its dead options too
        $$('select[data-option-index]', picker).forEach((select) => {
          const idx = Number(select.getAttribute('data-option-index'));
          Array.from(select.options).forEach((opt) => {
            opt.disabled = isUnavailable(idx, opt.value, current);
          });
        });
      }

      function update() {
        const current = selected();
        const variant = match(current);
        updateOptionAvailability(current);

        // Selected option label text. Matched by option index rather than by
        // position, because dropdown options carry no label element and would
        // otherwise shift every later label onto the wrong option.
        $$('[data-selected-value]', picker).forEach((el, i) => {
          const attr = el.getAttribute('data-option-index');
          const idx = attr === null ? i : Number(attr);
          if (current[idx]) el.textContent = current[idx];
        });

        if (!variant) {
          if (addBtn) {
            addBtn.disabled = true;
            addBtn.textContent = S.strings.unavailable;
          }
          return;
        }

        if (idInput) idInput.value = variant.id;

        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? S.strings.addToCart : S.strings.soldOut;
        }

        if (priceEl) {
          const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
          priceEl.classList.toggle('price--on-sale', !!onSale);
          const cur = $('.price__current', priceEl);
          const cmp = $('.price__compare', priceEl);
          if (cur) cur.textContent = S.formatMoney(variant.price);
          if (cmp) {
            cmp.textContent = onSale ? S.formatMoney(variant.compare_at_price) : '';
            cmp.hidden = !onSale;
          }
          const badge = $('[data-discount-badge]', sectionEl);
          if (badge) {
            if (onSale) {
              badge.textContent = '-' + Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100) + '%';
              badge.hidden = false;
            } else {
              badge.hidden = true;
            }
          }
        }

        if (inventoryEl) {
          inventoryEl.className = 'product-form__inventory product-form__inventory--' + (variant.available ? 'in' : 'out');
          const text = $('span', inventoryEl);
          if (text) text.textContent = variant.available ? inventoryEl.dataset.inStock : inventoryEl.dataset.outOfStock;
        }

        if (gallery && variant.featured_media_id) {
          gallery.dispatchEvent(new CustomEvent('gallery:select', { detail: { id: variant.featured_media_id } }));
        }

        // Sticky bar mirrors the main form
        const stickyPrice = $('[data-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = S.formatMoney(variant.price);
        const stickyId = $('[data-sticky-atc] input[name="id"]');
        if (stickyId) stickyId.value = variant.id;

        if (updateUrl && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }

        repriceVariantBundle(picker, variants, current);

        picker.dispatchEvent(new CustomEvent('variant:change', { detail: { variant }, bubbles: true }));
      }

      bindBundleItemRows(picker);
      picker.addEventListener('change', update);
      update();
    });
  }
  S.initVariants = initVariants;

  /* ---------- bundle picker --------------------------------------------- */
  // Tiers show quantity-based pricing. The percentages here only describe what
  // the automatic discounts in Shopify will do — they do not create the
  // discount, so the two have to be kept in step.
  function initBundlePicker(root) {
    $$('[data-bundle-picker]', root || document).forEach((picker) => {
      if (picker.dataset.bound) return;
      picker.dataset.bound = '1';

      const sectionEl = picker.closest('[data-product-section]') || document;
      const form = $('[data-product-form]', sectionEl);
      const tiers = $$('[data-bundle-tier]', picker);
      if (!tiers.length) return;

      // The quantity stepper is not rendered when a bundle picker exists, so
      // the chosen tier has to supply the quantity the form posts.
      function syncQuantity() {
        if (!form) return;
        const checked = tiers.find((t) => $('input', t).checked) || tiers[0];
        const qty = Number(checked.dataset.qty) || 1;
        let input = form.querySelector('input[name="quantity"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'quantity';
          form.appendChild(input);
        }
        input.value = qty;
      }

      // Variant catalogue, so a row's option combination can be resolved to a
      // real variant and its own price.
      let variants = [];
      const dataEl = $('[data-variant-json]', sectionEl);
      if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; } }

      const rowVariant = (row) => {
        const opts = $$('[data-bundle-option]', row).map((s) => s.value);
        return variants.find((v) => v.options.every((o, i) => o === opts[i]));
      };

      // Each row shows the design it is actually set to, so a mixed bundle
      // reads at a glance instead of every line looking identical.
      function paintThumbs() {
        $$('[data-bundle-row]', picker).forEach((row) => {
          const img = $('[data-bundle-thumb]', row);
          if (!img) return;
          const v = rowVariant(row);
          if (v && v.featured_image) img.src = v.featured_image;
        });
      }

      S.bundleItems = function (form) {
        if (!form || !sectionEl.contains(form)) return null;
        const tier = tiers.find((t) => $('input', t).checked);
        if (!tier) return null;
        const rows = $$('[data-bundle-row]', tier);
        if (!rows.length) return null;

        // Same variant chosen twice becomes one line with quantity 2, which is
        // what the quantity-based automatic discount counts.
        const counts = new Map();
        for (const row of rows) {
          const v = rowVariant(row);
          if (!v) return null;
          counts.set(v.id, (counts.get(v.id) || 0) + 1);
        }
        return Array.from(counts, ([id, quantity]) => ({ id: Number(id), quantity }));
      };

      function repriceFor(variant) {
        if (!variant) return;
        const unit = Number(variant.price) || 0;
        let unitCompare = Number(variant.compare_at_price) || 0;
        if (unitCompare < unit) unitCompare = unit;

        tiers.forEach((tier) => {
          const qty = Number(tier.dataset.qty) || 1;
          const off = Number(tier.dataset.discount) || 0;

          // Rows can hold different sizes at different prices, so the tier
          // total is the sum of what was actually picked — not qty x unit.
          const rows = $$('[data-bundle-row]', tier);
          let gross = unit * qty;
          let compare = unitCompare * qty;
          if (rows.length) {
            gross = 0; compare = 0;
            for (const row of rows) {
              const v = rowVariant(row);
              const p = v ? Number(v.price) : unit;
              let c = v ? Number(v.compare_at_price) || 0 : unitCompare;
              if (c < p) c = p;
              gross += p; compare += c;
            }
          }

          const total = Math.round((gross * (100 - off)) / 100);
          const save = compare - total;

          const set = (sel, text) => { const el = $(sel, tier); if (el) el.textContent = text; };
          set('[data-bundle-total]', S.formatMoney(total));
          set('[data-bundle-compare]', S.formatMoney(compare));
          set('[data-bundle-each]', (S.strings.bundleEach || '[amount] each').replace('[amount]', S.formatMoney(Math.round(total / qty))));
          set('[data-bundle-save]', (S.strings.bundleSave || 'Save [amount]').replace('[amount]', S.formatMoney(save)));

          const pctEl = $('[data-bundle-pct]', tier);
          if (pctEl) pctEl.textContent = '-' + (compare > 0 ? Math.round((save / compare) * 100) : 0) + '%';

          const saveEl = $('[data-bundle-save]', tier);
          if (saveEl) saveEl.hidden = save <= 0;
        });
      }

      // initVariants fires its first variant:change before this picker is
      // bound, so seed the current variant from what the form already holds.
      const idInput = form && form.querySelector('input[name="id"]');
      let currentVariant = idInput
        ? variants.find((v) => String(v.id) === String(idInput.value))
        : variants[0];

      const reprice = () => repriceFor(currentVariant);

      picker.addEventListener('change', (e) => {
        // A row the shopper has set keeps its value when the main picker moves.
        if (e.target.matches('[data-bundle-option]')) e.target.dataset.touched = '1';
        syncQuantity();
        reprice();
        paintThumbs();
      });

      document.addEventListener('variant:change', (e) => {
        currentVariant = (e.detail && e.detail.variant) || currentVariant;
        if (currentVariant) {
          $$('[data-bundle-option]', picker).forEach((sel) => {
            if (sel.dataset.touched) return;
            const value = currentVariant.options[Number(sel.dataset.bundleOption)];
            if (value != null) sel.value = value;
          });
        }
        reprice();
        syncQuantity();
        paintThumbs();
      });

      syncQuantity();
      reprice();
      paintThumbs();
    });
  }
  S.initBundlePicker = initBundlePicker;

  /* ---------- quick view ------------------------------------------------ */
  function initQuickView() {
    const modal = $('#QuickViewModal');
    if (!modal) return;
    const body = $('[data-quick-view-body]', modal);

    document.addEventListener('click', async (e) => {
      const trigger = e.target.closest('[data-quick-view]');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      const handle = trigger.getAttribute('data-quick-view');

      body.innerHTML =
        '<div class="grid grid--2"><div class="skeleton" style="padding-bottom:100%"></div>' +
        '<div><div class="skeleton" style="height:28px;margin-bottom:12px"></div>' +
        '<div class="skeleton" style="height:18px;width:60%;margin-bottom:20px"></div>' +
        '<div class="skeleton" style="height:44px"></div></div></div>';
      S.openOverlay && S.openOverlay('quick-view');

      try {
        const res = await fetch(
          S.routes.root.replace(/\/$/, '') + '/products/' + handle + '?section_id=quick-view'
        );
        if (!res.ok) throw new Error('not found');
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const content = doc.querySelector('[data-quick-view-content]');
        body.innerHTML = content ? content.innerHTML : '';
        initVariants(body);
        initBundlePicker(body);
        S.bindProductForms && S.bindProductForms(body);
        S.initGallery && S.initGallery(body);
      } catch (err) {
        body.innerHTML = '<p class="text-muted">' + (S.strings.error || 'Unavailable') + '</p>';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initVariants(document);
    initBundlePicker(document);
    initQuickView();
  });
  document.addEventListener('shopify:section:load', (e) => { initVariants(e.target); initBundlePicker(e.target); });
})();
